import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Twitter, Linkedin, Instagram, Github, Facebook } from "lucide-react";
import Logo from "./Logo";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const columns = [
  {
    title: "Services",
    links: [
      { label: "Website Design", to: "/oneoffpackages" },
      { label: "Website Redesign", to: "/oneoffpackages" },
      { label: "Website Care plans", to: "/carepackages" },
      { label: "Domain management", to: "/services/domain-management" },
      { label: "Custom email setup", to: "/services/custom-email" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Portfolio", to: "/portfolio" },
      { label: "Pricing", to: "/pricing" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "FAQ", to: "/faq" },
      { label: "Book a call", to: "/contact" },
      { label: "Privacy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
    ],
  },
];

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email, source: "footer" });
      toast.success("You're on the list. Welcome.");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-slate-950 text-slate-300" data-testid="site-footer">
      <div className="container-page pt-20 pb-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 text-slate-400 text-base leading-relaxed max-w-md">
              Smart websites. Grow businesses.
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-10">
            {columns.map((col) => (
              <div key={col.title}>
                <p className="text-white font-semibold mb-4">{col.title}</p>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        to={l.to}
                        className="text-slate-400 hover:text-white text-sm inline-flex items-center gap-1 transition-colors"
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                      >
                        {l.label}
                        <ArrowUpRight className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <p className="text-slate-500 text-sm">© {new Date().getFullYear()} SolkSites. All rights reserved.</p>
          <div className="flex items-center gap-4">
            {[
              // { Icon: Twitter, href: "#", label: "Twitter" },
              // { Icon: Linkedin, href: "#", label: "LinkedIn" },
              { Icon: Instagram, href: "https://www.instagram.com/solksites?igsh=MXkxdHF1Z2x4aGVnag%3D%3D&utm_source=qr", label: "Instagram" },
              { Icon: Facebook, href: "https://www.facebook.com/share/14kyi3x3WRs/?mibextid=wwXIfr", label: "Facebook" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                className="h-9 w-9 rounded-full border border-slate-800 hover:border-slate-600 flex items-center justify-center text-slate-400 hover:text-white transition-colors"
                data-testid={`footer-social-${label.toLowerCase()}`}
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
